import { createTheme } from "@mui/material/styles";

import { components } from "theme/components";
import { palette } from "theme/palette";
import { muiShadows } from "theme/shadows";
import { typography } from "theme/typography";

import { zIndex } from "design-tokens";

/**
 * Apollo's em-based custom breakpoints mapped onto MUI's standard keys, so no module augmentation is
 * needed. `beeLarge` (1171px) has no MUI key and is left out — nothing reads it.
 */
const breakpointValues = {
  xs: 0,
  sm: 461, // maxMobile (460) + 1
  md: 801, // maxTablet (800) + 1
  lg: 1281, // maxLaptop (1280) + 1
  xl: 1601, // maxDesktop (1600) + 1
};

export const apolloMuiTheme = createTheme({
  palette,
  typography,
  shadows: muiShadows,

  breakpoints: {
    values: breakpointValues,
  },

  shape: {
    borderRadius: 8,
    small: 4,
    medium: 6,
    large: 8,
  },

  /**
   * So MUI portals never lose to app chrome (#36796). `Popover`, `Menu` and `Select` render through
   * `Modal` and take `zIndex.modal`; one opened inside a dialog still wins on DOM order.
   */
  zIndex: {
    mobileStepper: zIndex.docked,
    fab: zIndex.floating,
    speedDial: zIndex.floating,
    appBar: zIndex.sticky,
    drawer: zIndex.overlay,
    modal: zIndex.modal,
    snackbar: zIndex.toast,
    tooltip: zIndex.tooltip,
  },

  components,
});

export default apolloMuiTheme;
